import { render, staticRenderFns } from "./BasicData.vue?vue&type=template&id=15e703b2&scoped=true"
import script from "./BasicData.vue?vue&type=script&lang=js"
export * from "./BasicData.vue?vue&type=script&lang=js"
import style0 from "./BasicData.vue?vue&type=style&index=0&id=15e703b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e703b2",
  null
  
)

export default component.exports